import {lazy} from 'react';
import {RoutesType} from "../types/types.ts";


const Main = lazy(() => import('../pages/main/Main.tsx'));
const Settings = lazy(() => import('../pages/settings/Settings.tsx'));
const AllChannels = lazy(() => import('../pages/allChannels/AllChannels.tsx'));
const ContactDetails = lazy(() => import('../pages/сontactDetails/ContactDetails.tsx'));
const ReferralStats = lazy(() => import('../pages/referralsStats/ReferralStats.tsx'));
const BlackList = lazy(() => import('../pages/blackList/BlackList.tsx'));
const Favourites = lazy(() => import('../pages/favourites/Favourites.tsx'));
const Campaigns = lazy(() => import('../pages/campaigns/Campaigns.tsx'));
const StorePage = lazy(() => import('../pages/storePage/StorePage.tsx'));
const PaymentPage = lazy(() => import('../pages/storePage/Payment.tsx'));
const PaymentStatus = lazy(() => import('../pages/storePage/PaymentStatus.tsx'));
const Profile = lazy(() => import('../pages/profile/Profile.tsx'));
const AddChannel = lazy(() => import('../pages/addChannel/AddChannel.tsx'));
const ChannelInfo = lazy(() => import('../pages/channel/Channel.tsx'));
const CompletingTheSetup = lazy(() => import('../pages/addChannel/CompletingTheSetup.tsx'));
const SettingsChannel = lazy(() => import('../pages/channel/AttractsChannelSettings.tsx'));
const CreateCampaign = lazy(() => import('../pages/campaigns/CreateCampaign.tsx'));
const InfoCampaign = lazy(() => import('../pages/campaigns/InfoAboutCampaignPage.tsx'));
const InfoAboutPublicationDraft = lazy(() => import('../pages/publications/InfoAboutPublicationDraft.tsx'));
const InfoAboutPublicationNoDraft = lazy(() => import('../pages/publications/InfoAboutPublicationNoDraft.tsx'));
const TransferCampaignSettings = lazy(() => import('../pages/campaigns/TransferCampaignSettings.tsx'));
const EngagementCampaignSettings = lazy(() => import('../pages/campaigns/EngagementCampaignSettings.tsx'));
const AddingPost = lazy(() => import('../pages/adddingPost/AddingPost.tsx'));
const AddingPublication = lazy(() => import('../pages/addinPubliation/AddingPublication'));
const CreatePublication = lazy(() => import('../pages/publications/CreatePublication.tsx'));
const CreatePublicationWithSelectChannels = lazy(() => import('../pages/publications/CreatePublicationWithMineChannels.tsx'));
const InfoAboutActualPublication = lazy(() => import('../pages/actualPublication/ActualPublication.tsx'));

// const PublicationDetails = lazy(() => import('../pages/channel/PublicationDetails.tsx'));


const routes: RoutesType[] = [
    {path: '/', element: Main, index: true},
    {path: '/all_channels', element: AllChannels, index: true},
    {path: '/settings', element: Settings, index: true},
    {path: '/referrals_stats', element: ReferralStats, index: true},
    {path: '/adding_post', element: AddingPost, index: true},
    {path: '/adding_publication', element: AddingPublication, index: true},
    {path: '/contact_details', element: ContactDetails, index: true},
    {path: '/blacklist', element: BlackList, index: true},
    {path: '/favourites', element: Favourites, index: true},
    {path: '/campaigns', element: Campaigns, index: false},
    {path: '/store', element: StorePage, index: false},
    {path: '/payment_details', element: PaymentPage, index: false},
    {path: '/payment_status', element: PaymentStatus, index: false},
    {path: '/profile', element: Profile, index: false},
    {path: '/addChannel', element: AddChannel, index: false},
    {path: '/addChannel_step2', element: CompletingTheSetup, index: false},
    {path: '/channel_info', element: ChannelInfo, index: false},
    {path: '/channel_settings', element: SettingsChannel, index: false},
    {path: '/create_campaign', element: CreateCampaign, index: false},
    {path: '/campaign_info', element: InfoCampaign, index: false},
    {path: '/transfer_campaign_settings', element: TransferCampaignSettings, index: false},
    {path: '/engagement_campaign_settings', element: EngagementCampaignSettings, index: false},
    // {path: '/publication_details', element: PublicationDetails, index: false},
    {path: '/info_about_publication_draft', element: InfoAboutPublicationDraft, index: false},
    {path: '/info_about_publication', element: InfoAboutPublicationNoDraft, index: false},
    {path: '/create_publication', element: CreatePublication, index: false},
    {path: '/create_publication_2', element: CreatePublicationWithSelectChannels, index: false},
    {path: '/info_about_ActualPublication', element: InfoAboutActualPublication, index: false},
]

export default routes
